<template>
    <div>
        <div class="loader" v-if="this.isLoading"></div>   
        <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
        <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
            <!--begin::navbar-->
            <navbar-component></navbar-component>
            <!--end::navbar-->
  
  
        <div class="page-wrapper">
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                <div class="card">
                  <div class="card-header">
                        <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                         &nbsp;&nbsp;&nbsp;
                        <h6 class="card-title mb-0 float-start" style="padding-left: 25px">{{ $t("wa_message_detail") }}</h6>
                        <button
                        class="btn btn-light float-end"
                        type="button"
                        data-bs-toggle="collapse" 
                        data-bs-target="#collapseExample" 
                        aria-expanded="false" 
                        aria-controls="collapseExample"
                        >
                      <i class="link-icon" data-feather="info"></i>
                      Audit Info
                    </button>
  
                    <div class="row mb-3 collapse" id="collapseExample" style="padding-left:20px">
                      <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0 ">Created By:</label>
                        <p class="text-muted">{{this.forms.create_by}}</p>
                      </div>
  
                      <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0">Created At:</label>
                        <p class="text-muted">{{this.forms.created_at}}</p>
                      </div>
  
                      <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                        <p class="text-muted">{{this.forms.update_by}}</p>
                      </div>
  
                      <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                        <p class="text-muted">{{this.forms.updated_at}}</p>
                      </div>
  
                      
                      
                    </div>
                  </div>
                  <div class="card-body">
                 
                       
                        <div class="row mb-3">
                            <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                                $t("from_phone_number")
                            }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="from_phone_number"
                                    :placeholder="$t('from_phone_number')"
                                    v-model="forms.from_phone_number"
                                    disabled
                                />


                                <div v-if="errors.from_phone_number">
                                  <div
                                    v-for="error in errors.from_phone_number"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                  >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                  </div>
                                </div>
                         
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                                $t("app_form")
                            }}</label>
                            </div>
                            <div class="col-lg-8">
                                
                                <input
                                    type="text"
                                    class="form-control"
                                    id="app_form"
                                    :placeholder="$t('app_form')"
                                    v-model="forms.app_form"
                                    disabled
                                />


                                <div v-if="errors.app_form">
                                  <div
                                    v-for="error in errors.app_form"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                  >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                  </div>
                                </div>
                         
                            </div>
                        </div>

                        
                        <div class="row mb-3">
                            <div class="col-lg-2">
                            <label for="phone_number" class="col-form-label" style="padding-left: 25px">{{
                                $t("phone_number")
                            }}</label>
                            </div>
                            <div class="col-lg-8">
                               
                                <input
                                    type="text"
                                    class="form-control"
                                    id="phone_number"
                                    :placeholder="$t('phone_number')"
                                    v-model="forms.phone_number"
                                    disabled
                                />

                                <div v-if="errors.phone_number">
                                  <div
                                    v-for="error in errors.phone_number"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                  >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                  </div>
                                </div>
 

 
                            </div>
                        </div>
    
    
                        <div class="row mb-3">
                            <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                                $t("type")
                            }}</label>
                            </div>
                            <div class="col-lg-8">
                                
                            
                                <input
                                    type="text"
                                    class="form-control"
                                    id="type"
                                    :placeholder="$t('type')"
                                    v-model="forms.type"
                                    disabled
                                />


                                <div v-if="errors.type">
                                  <div
                                    v-for="error in errors.type"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                  >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                  </div>
                                </div>
                         
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                                $t("sid")
                            }}</label>
                            </div>
                            <div class="col-lg-8">
                                
                            
                                <input
                                    type="text"
                                    class="form-control"
                                    id="sid"
                                    :placeholder="$t('sid')"
                                    v-model="forms.sid"
                                    disabled
                                />


                                <div v-if="errors.sid">
                                  <div
                                    v-for="error in errors.sid"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                  >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                  </div>
                                </div>
                         
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                                $t("statusTxt")
                            }}</label>
                            </div>
                            <div class="col-lg-8">
                                
                            
                                <input
                                    type="text"
                                    class="form-control"
                                    id="status"
                                    :placeholder="$t('statusTxt')"
                                    v-model="forms.status"
                                    disabled
                                />


                                <div v-if="errors.status">
                                  <div
                                    v-for="error in errors.status"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                  >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                  </div>
                                </div>
                         
                            </div>
                        </div>


                        <div class="row mb-3" v-if="forms.type === 'text'">
                            <div class="col-lg-2">
                            <label for="message" class="col-form-label" style="padding-left: 25px">{{
                                $t("message")
                            }}</label>
                            </div>
                            <div class="col-lg-8">

                                <textarea id="message" v-model="forms.message" class="form-control" rows="4" cols="50" :placeholder="$t('message')" disabled>

                                </textarea>

                                <div v-if="errors.message">
                                  <div
                                    v-for="error in errors.message"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                  >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                  </div>
                                </div>
 

 
                            </div>
                        </div>
                        <div class="row mb-3" v-else>
                            <div class="col-lg-2">
                            <label for="attachment" class="col-form-label" style="padding-left: 25px">{{
                                $t("attachment")
                            }}</label>
                            </div>
                            <div class="col-lg-8">
                                
                                <a :href="forms.attachment" target="_blank">{{$t("download_attachment")}}</a>
                               

                                <div v-if="errors.attachment">
                                  <div
                                    v-for="error in errors.attachment"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                  >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                  </div>
                                </div>
 

 
                            </div>
                        </div>
                     
                     
                        <div class="card-footer">
                        <button
                            class="
                                btn btn-warning
                                text-black
                                fw-bolder
                                btn-icon-text
                            "
                            @click="backForm"
                            type="button"
                            >
                            <i class="link-icon" data-feather="arrow-left"></i>
                            {{ $t("backMess") }}
                            </button>
                            
                            &nbsp;&nbsp;&nbsp;
                            <a
                            v-if="permision_role.method_delete"
                            class="
                              btn btn-danger
                              text-white
                              fw-bolder
                              btn-icon-text
                              float-end
                            "
                            @click="deleteData()"
                          >
                            <i class="link-icon" data-feather="trash"></i>
                            {{ $t("deleteMess") }}
                          </a>
    
                          <a
                            v-if="permision_role.method_update"
                            class="
                              btn btn-primary
                              me-2
                              text-white
                              fw-bolder
                              btn-icon-text
                              float-end
                            "
                            @click="editData()"
                          >
                            <i class="link-icon" data-feather="edit"></i>
                            {{ $t("editMess") }}
                          </a>
                        </div>
 
                  </div>
                </div> <!--end::card-->
              </div>
            </div>
          </div>
          <!--end::content-->
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
</template>
  
  
  <script>
  import navbarComponent from "@/components/_partials/_navbar";
  import footerComponent from "@/components/_partials/_footer";
  
  export default {
    name: "WaMessageDetail",
    props: {},
    components: {
      "navbar-component": navbarComponent,
      "footer-component": footerComponent,
    },
    data() {
      return {
        fileAttachment: '',
        fetchFromPhoneNumber:[],
        fetchType:["text","file"],
        fetchAppForm:['middleware','sharepoint','driver-payroll'],
        FromPhoneNumber:"",
        isLoading: false,
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        errors: [],
        userData: "",
        companyCode: "",
        fetchUserType:[],
        user_type:[],
        fetchRole:[],
        fetchCompany:[],
        fetchCompanyNotLinc:[],
        permision_role:[],
        company:[],
        role:[],
        forms: { 
            id_whatsapp_msg: "",
            from_phone_number: "",
            phone_number: "",
            message: "",
            attachment: "",
            app_form: "",
            status: "new",
            created_at: "",
            updated_at: "",
            create_by: "",
            sid: "",
            type: "",
            update_by: "",
        },
      };
    },
    watch: {},
    methods: {
 

        editData(){
            var params = this.$route.params.id
            window.location.href = "/whatsapp/message-data/edit/"+ params;
        },

        deleteData() {
            var id = this.$onBehind(this.$route.params.id);
            this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourDataDelete"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
            }).then((result) => {
            if (result.value) {
                var formData = {
                status: status,
                };
                const baseURI =
                this.$settings.endPointWhatsapp + "api/dashboard/message/delete/" + id;
                this.$http
                .delete(baseURI, formData,{ timeout: 10000 })
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                    this.success(response.data.datas.messages);
                    window.location.href = "/whatsapp/message-data";
                    } else {
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                    }
                })
                .catch((error) => {
                    this.loading();
                    if(error.code == "ECONNABORTED"){
                    this.error(this.$t("check_internet_connection_txt"));
                    
                    }else{
    
                    if (error.response) {
                            if(error.response.status === 422) {
                                    this.errors = error.response.data.errors;
                                    this.resultError(error.response.data.errors);
                            }else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            }else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            }else{
                                this.$router.push('/page-not-found');
                            }
                        }
    
                    }
                });
            }else{
                this.isLoading = false;
            }
            });
        },
  
        resetForm() {
            this.forms.id_whatsapp_msg = "" ;
            this.forms.from_phone_number = "" ;
            this.forms.phone_number = "" ;
            this.forms.message = "" ;
            this.forms.attachment = "" ;
            this.forms.app_form = "" ;
            this.forms.status = "new" ;
            this.forms.created_at = "" ;
            this.forms.updated_at = "" ;
            this.forms.create_by = "" ;
            this.forms.sid = "" ;
            this.forms.type = "" ;
            this.forms.update_by = "" ;
        },
  
  
        backForm() {
            window.location.href = "/whatsapp/message-data";
        },
    
  
        fade(sType) {
            this.isLoading = sType;
        },
    
        loading() {
            this.fade(true);
            setTimeout(() => {
            this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },
  
        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
            var nameOb = Object.keys(data)[x];
            var objectData = data[nameOb];
            for (var y = 0; y < objectData.length; y++) {
                this.error(objectData[y]);
            }
            }
        },
  
        resultErrorExpress(data) {
            
            for (var x = 0; x < data.length; x++) {
                var objectData = data[x] 
                var messsage = objectData.param + " : " + objectData.msg
                this.error(messsage);
            }
        },
  
        success(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            });
            Toast.fire({
            icon: "success",
            title: kata,
            });
        },
  
        error(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            });
            Toast.fire({
            icon: "error",
            title: kata,
            });
        },
  
        fetchIt() {
            const userDatas     = this.$getUserInfo();
            this.detailUser     = userDatas.sub;
            this.companyCode = this.detailUser.company_detail.code;
            // this.permision_role = userDatas.sub.permision_role;
            this.companyCode = this.detailUser.company_detail.code;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function(permision){
            if(permision.permission.controller == 'WaMessageController'){
                rolePermision = permision;
                // console.log(permision);
            }
            });
    
            if(!rolePermision.method_create){
            this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;
    
        },
        
        cek_message(status,msg){
            if(status=='200'){
            this.success(msg);
            }
        },
  
        loadData(id) {
            const baseURI = this.$settings.endPointWhatsapp + "api/dashboard/message/detail/"+id;
            this.isLoading = true;
            return this.$http
            .get(
                baseURI,{ timeout: 10000 }
            )
            .then((response) => {
                this.forms      = response.data.datas;
                this.isLoading = false;
                
            }).catch(error => {
                this.isLoading = false;
                if(error.code == "ECONNABORTED"){
                this.error(this.$t("check_internet_connection_txt"));
                
                }else{
    
                if (error.response) {
                  if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  }else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                  }else{
                    this.$router.push('/page-not-found');
                  }
                }
    
                }
            });
        },
  
        logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
              
            console.log(response);

          });

          // clearSessionBillingToken(localStorage.getItem(this.$settings.jwtSecret));

          this.$logoutUser();
          window.location.href = '/';
        },

    },
    events: {},
    created: function () {},
    mounted() {
        var params = this.$onBehind(this.$route.params.id);
        this.cek_message(this.$route.query.status,this.$route.query.msg);
        this.fetchIt();
         this.loadData(params[0]);
    },
  };
  </script>
  <style scoped>
  button.gm-ui-hover-effect {
    visibility: hidden;
  }
  
  .blur-content{
    filter: blur(5px); 
    pointer-events: none;
    
  }
  </style>